import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import {
  MoreHorizontal,
  Pencil,
  Globe,
  GlobeLock,
  Trash2,
} from "lucide-react";
import type { HandbookListItem } from "@/types/handbook";

export type HandbookAction = "edit" | "publish" | "unpublish" | "delete";

interface HandbookActionsProps {
  item: HandbookListItem;
  onAction: (item: HandbookListItem, action: HandbookAction) => void;
}

export function HandbookActions({ item, onAction }: HandbookActionsProps) {
  const isPublished = item.status === "published";
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-8 w-8 p-0"
          aria-label="작업 메뉴 열기"
        >
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onAction(item, "edit")}
          className="cursor-pointer"
        >
          <Pencil className="mr-1 h-4 w-4" />
          수정
        </DropdownMenuItem>
        {isPublished ? (
          <DropdownMenuItem
            onClick={() => onAction(item, "unpublish")}
            className="cursor-pointer"
          >
            <GlobeLock className="mr-1 h-4 w-4" />
            발행 취소
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            onClick={() => onAction(item, "publish")}
            className="cursor-pointer"
          >
            <Globe className="mr-1 h-4 w-4" />
            발행
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onAction(item, "delete")}
          className="text-destructive focus:text-destructive cursor-pointer"
        >
          <Trash2 className="text-destructive mr-1 h-4 w-4" />
          삭제
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
